import { render, staticRenderFns } from "./index_alive.vue?vue&type=template&id=782b0d90&scoped=true"
import script from "./index_alive.vue?vue&type=script&lang=js"
export * from "./index_alive.vue?vue&type=script&lang=js"
import style0 from "./index_alive.vue?vue&type=style&index=0&id=782b0d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b0d90",
  null
  
)

export default component.exports